import { Directive } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Directive({
    selector: '[caForm]',
    exportAs: 'formTools'
})
export class FormDirective {
    public form = new FormGroup<{ [key: string]: FormControl<string | number | boolean> | FormGroup<any> }>({});
}
